.atm_iy_kbqlyw{max-height:450px;}
.atm_l8_idpfg4{padding:0;}
.atm_5j_ftgil2{border-radius:8px;}
.atm_j3_1lr2qm4{max-width:calc(100vw - 16px);}
.atm_e2_kbqlyw{height:450px;}
.atm_9s_1txwivl{display:flex;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_7bqm3g_15xxhlz.atm_7bqm3g_15xxhlz *{font-family:'DM Sans',sans-serif;}
.atm_vy_1y44olf{width:4px;}
.atm_e2_1y44olf{height:4px;}
.atm_2d_qgx6rq.atm_2d_qgx6rq{background-color:#6F7780;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_9s_1o8liyq{display:inline-block;}
.atm_gi_wex8y9{margin:0px 2px;}
@keyframes emoji-blink {
    0%,
    100% {
      opacity: 0.3;
    }
    50% {
      opacity: 1;
      transform: scale(1.3);
    }
  }
.atm_gz_ftgil2.atm_gz_ftgil2{margin-left:8px;}
.atm_h3_ftgil2.atm_h3_ftgil2{margin-top:8px;}
.atm_1smt8mw_1yyfdc7::before,.atm_1smt8mw_1yyfdc7::after{content:'';}
.atm_1r5jvjd_1y44olf::before,.atm_1r5jvjd_1y44olf::after{width:4px;}
.atm_qguyfe_1y44olf::before,.atm_qguyfe_1y44olf::after{height:4px;}
.atm_r9jpo0_qgx6rq.atm_r9jpo0_qgx6rq::before,.atm_r9jpo0_qgx6rq.atm_r9jpo0_qgx6rq::after{background-color:#6F7780;}
.atm_w52pfw_1y44olf::before,.atm_w52pfw_1y44olf::after{border-radius:4px;}
.atm_11m2q5y_1o8liyq::before,.atm_11m2q5y_1o8liyq::after{display:inline-block;}
.atm_gz5rnt_wex8y9::before,.atm_gz5rnt_wex8y9::after{margin:0px 2px;}
.atm_epdjz_gyomky::before{animation:emoji-blink 1.5s ease infinite 0.5s;}
.atm_1jbuh0v_1vwylxq::after{animation:emoji-blink 1.5s ease infinite 1.5s;}
.atm_p_ob1558{animation:emoji-blink 1.5s ease infinite 1s;}
